import type { WCallTranslations } from "./pl";

export const en: WCallTranslations = {
  widgetAriaLabel: "Leave your number, we'll call you back",
  consultantAlt: "Consultant",
  closeLabel: "Close",

  crmModeWithoutModule: {
    body1: "The window is configured to send to CRM, but the module",
    moduleName: "m_crm_sales_support",
    body2:
      'is not active in this domain. Enable the module in the admin panel or change the send mode to "email" in the window configuration.',
  },
  unknownSendMode: (mode) => `Unknown send mode in window configuration: ${mode}.`,

  cta: {
    leaveNumber: "Leave your number",
  },

  now: {
    title: "Get in touch",
    intro:
      "Enter your phone number - our consultant will call you back as soon as possible.",
    btnNow: "Call me back now",
    btnLater: "Pick a time",
  },

  later: {
    title: "Choose a convenient time",
    intro: "Pick a day and time - we'll call back on the chosen date.",
    btnSubmit: "Schedule a call",
    btnBack: "Back",
  },

  labels: {
    telephone: "Phone",
    day: "Day",
    hour: "Hour",
  },

  placeholders: {
    selectDay: "Choose a day",
    selectHour: "Choose a time",
  },

  sending: "Sending...",

  validation: {
    requiredPhone: "Phone number is required.",
    invalidPhone: "Invalid phone number.",
    requiredDay: "Pick a day.",
    invalidDay: "Invalid day.",
    requiredHour: "Pick a time.",
    invalidHour: "Invalid time.",
  },

  status: {
    waitBeforeSubmit: (seconds) =>
      `Please wait ${seconds} more seconds before submitting.`,
    rateLimit: "Too many attempts from this IP address. Try again in a moment.",
    sendFailed: "Failed to save the request.",
    sendSuccess: "Thanks - we'll call you back as soon as possible.",
    networkError: (message) => `Network error: ${message}`,
    networkErrorGeneric: "Network error while sending.",
  },
};
